import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import { ApiGet, ApiPut, ApiDelete, ApiPost } from "../../../helpers/API/ApiData";
import { customStyles } from "../tableStyle";
import { TailSpin } from "react-loader-spinner";
import "./eventsData.scss";
import { toast } from "react-toastify";
import useDebounce from "../../../hooks/useDebounceHook";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { Trash } from "react-feather";
import { Button } from "reactstrap";

import Select from "react-select";

import moment from "moment";
import DatePicker from "react-datepicker";
import "moment-timezone";
import AddLocationModel from "./addLocationModel";
import { Modal } from "react-bootstrap";
import { downloadExcel } from "../../../helpers/Common";
import DownloadFilterModel from "../../commonComponent/donwloadFilterModel";

export default function EventsData() {
  const [getEventData, setGetEventData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [count, setCount] = useState(0);

  const [loading, setLoading] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue, 900);

  const [filterData, setFilterData] = useState({});

  const [violateOption, setViolateOption] = useState();
  const [locationOption, setLocationOption] = useState();
  const [locationNames, setLocationNames] = useState([]);
  const [locationLoader, setLocationLoader] = useState(false);
  const [searchLoaction, setSearchLoaction] = useState();

  const debouncedSearchLocation = useDebounce(searchLoaction, 900);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [donwloadModel, setDonwloadModel] = useState({
    isOpen: false,
    startDate: null,
    endDate: null,
    violateOption: null,
    loading: false,
    locationId: null,
  });

  const isAssignViolateOption = [
    {
      value: "",
      label: "Alle",
    },
    {
      value: true,
      label: "verletzen",
    },
    {
      value: false,
      label: "nicht flüchtig",
    },
  ];

  const ProjectStyle = {
    control: (provided, state) => ({
      ...provided,
      maxWidth: "150px",
      fontSize: "12px",
      marginLeft: "30px",
      border: state.isFocused ? "2px solid #73AA85 !important" : "",
      boxShadow: "1px solid #73AA85 !important",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      color: state.isSelected ? "white" : "black", // Change selected color here
      backgroundColor: state.isSelected ? "#73AA85" : "white",
      "&:hover": {
        backgroundColor: "#73AA85",
      },
    }),
    menu: (provided) => ({
      ...provided,
      maxWidth: "150px",
      marginLeft: "30px",
      zIndex: "999",
    }),
  };

  const columns = [
    {
      name: "SNo",
      cell: (row, index) => {
        return <p>{(page - 1) * countPerPage + index + 1}</p>;
      },
      width: "60px",
    },
    {
      name: <span>Kennzeichen</span>,
      width: "250px",
      selector: (row) => {
        return <div>{row.plateNumber ? row.plateNumber : "-"}</div>;
      },
    },

    // {
    //   name: "Geräte-ID",
    //   width: "200px",
    //   selector: (row) => <div className="profileImage">{row.deviceId ? row.deviceId : "-"}</div>,
    // },
    {
      name: "Richtung",
      width: "200px",
      selector: (row) => <div className="profileImage">{row.direction ? row.direction : "-"}</div>,
    },
    {
      name: <span>Eintrittszeit </span>,
      minWidth: "200px",
      selector: (row) => <div className="profileImage">{row.entryTime ? <Moment format="DD-MM-YYYY , HH:mm:ss" tz="CET" date={row.entryTime} /> : "-"}</div>,
    },
    {
      name: <span>Austrittszeit</span>,
      minWidth: "200px",
      selector: (row) => <div className="profileImage">{row.exitTime ? <Moment format="DD-MM-YYYY , HH:mm:ss" tz="CET" date={row.exitTime} /> : "-"}</div>,
    },
    {
      name: <span>Parkzeit</span>,
      minWidth: "200px",
      selector: (row) => <div className="profileImage">{row.totalParkingTime ? row.totalParkingTime + " Minuten" : "-"}</div>,
    },

    {
      name: "Abstrafungen",
      width: "200px",
      selector: (row) => {
        const statusClass = row?.isViolation ? "new-deisgn-statusooooooooooo" : "newstatusppppppppppp";
        return <div className={statusClass}>{row.isViolation ? "Ja" : "NEIN"}</div>;
      },
    },
  ];

  useEffect(() => {
    handleChangeCommom("", "", filterData);
  }, [debouncedSearchValue, page, countPerPage, violateOption, locationOption, filterData]);

  const handleGetSalesPatner = async () => {
    setLocationLoader(true);
    try {
      const response = await ApiGet(`dahualocation/getAllLocations?limit=${10}&page=${1}${debouncedSearchLocation ? `&search=${searchLoaction}` : ""}`);
      const data = response?.data?.payload;
      if (data && Array.isArray(data)) {
        const optionData = data.map((item) => ({
          value: item?._id,
          label: item?.name,
        }));

        setLocationNames(optionData);
        setLocationLoader(false);
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        setLocationNames([]);
        setLocationLoader(false);
      } else {
        setLocationLoader(false);
        toast.error("Etwas ist schief gelaufen");
      }
    }
  };

  useEffect(() => {
    handleGetSalesPatner();
  }, [debouncedSearchLocation]);

  // useEffect(() => {
  //   handleGetSalesPatner();
  // }, []);

  const handleChangeCommom = async (e, key, filter) => {
    setLoading(true);

    try {
      const response = await ApiGet(`dahualocation/getLocationEvents?limit=${countPerPage}&page=${page}${debouncedSearchValue ? `&search=${searchValue}` : ""}${violateOption?.value ? `&isViolation=${violateOption?.value}` : ""}${locationOption ? `&locationId=${locationOption?.value}` : ""}${filter?.startDate ? `&startDate=${filter?.startDate}` : ""}${filter?.endDate ? `&endDate=${filter?.endDate}` : ""}`);
      setCount(response?.data?.payload.totalCount);
      setGetEventData(response?.data?.payload.events);
      setLoading(false);
    } catch (error) {
      if (error?.response?.status === 404) {
        setGetEventData();
      }
      toast.error(error);
      setLoading(false);
    }
  };

  const customNoDataComponent = () => <div style={{ textAlign: "center", padding: "10px 0px", fontSize: "16px" }}>Aktuell sind keine Daten vorhanden.</div>;

  const handleChangeAssign = (data, name) => {
    if (name === "violation") {
      setViolateOption(data);
    } else if (name === "location") {
      setLocationOption(data);
    } else if (name === "forDownload") {
      setDonwloadModel({ ...donwloadModel, violateOption: data });
    } else if (name === "downloadLocation") {
      setDonwloadModel({ ...donwloadModel, locationId: data });
    }
  };

  const handleOnChange = (dates, name) => {
    const [start, end] = dates;
    if (name === "forFilter") {
      setStartDate(start);
      setEndDate(end);
      if (end) {
        const params = { ...filterData, startDate: moment(start).format("YYYY-MM-DD"), endDate: moment(end).format("YYYY-MM-DD") };
        setFilterData(params);
      }
    } else if (name === "forDownload") {
      setDonwloadModel({ ...donwloadModel, startDate: start, endDate: end });
    }
  };

  const handleCloseDownloadModel = () => {
    setDonwloadModel({
      isOpen: false,
      startDate: null,
      endDate: null,
      violateOption: null,
      loading: false,
      locationId: null,
    });
  };

  return (
    <div>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className="standortdetails">
            <div>
              <h2 className="pl-3 pt-2 all-title">Alle Parkevents</h2>
            </div>
            {/* <div className="col-lg-9 justify-content-end align-items-center row header-flex-item-2"> */}
            <div className="veranstaltungen-content" style={{ gap: "20px" }}>
              <div className={` reactDatePicker`}>
                <DatePicker selected={startDate} startDate={startDate} endDate={endDate} dateFormat="dd/MM/yyyy" placeholderText="Datum" maxDate={new Date()} onChange={(e) => handleOnChange(e, "forFilter")} onKeyDown={(e) => e.preventDefault()} selectsRange fixedHeight />
              </div>

              <div className="header-items">
                <div className="project-Dropdown  project-Dropdown-sc">
                  <Select
                    className="Select-main"
                    value={locationOption}
                    name="location"
                    onChange={(e) => handleChangeAssign(e, "location")}
                    options={locationLoader ? [{ value: "Loading...", name: "Loading..." }] : locationNames}
                    styles={ProjectStyle}
                    defaultValue={locationOption}
                    placeholder="Standorte"
                    isClearable={true}
                    onInputChange={(value) => setSearchLoaction(value)}
                    cacheOptions
                    // isSearchable={false}
                  />
                </div>
              </div>

              <div className="header-items">
                <div className="project-Dropdown project-Dropdown-sc">
                  <Select
                    className="Select-main"
                    // menuIsOpen={true}
                    value={violateOption}
                    name="isAssign"
                    onChange={(e) => handleChangeAssign(e, "violation")}
                    options={isAssignViolateOption}
                    styles={ProjectStyle}
                    defaultValue={violateOption}
                    placeholder="Abstrafungen"
                    isClearable={true}
                  />
                </div>
              </div>

              <div className="search-input-main">
                <input
                  type="search"
                  className={`form-control form-control-lg form-control-solid `}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setLoading(true);
                  }}
                  name="search"
                  value={searchValue}
                  placeholder="Suche"
                />
              </div>

              <div className="header-items cus-medium-button-style button-height pr-2 mt-lg-0 cusbutton-moblie addbutton-main">
                <div
                  onClick={() => {
                    setDonwloadModel({
                      isOpen: true,
                      startDate: null,
                      endDate: null,
                      violateOption: null,
                      loading: false,
                      locationId: null,
                    });
                  }}
                  style={{ width: "100%", justifyContent: "center", alignItems: "center", display: "flex", cursor: "pointer" }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 512 512" fill="#FFDF5C">
                    <path d="M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3L304 256l0-96c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 96-57.7 0C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z" />
                  </svg>
                </div>
              </div>
            </div>
            {/* </div> */}
          </div>
          <DataTable
            data={getEventData}
            columns={columns}
            responsive
            noDataComponent={customNoDataComponent()}
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            className="new_data__table table_height"
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[5, 10, 20, 25, 50]}
            paginationDefaultPage={page}
            progressPending={loading}
            progressComponent={
              <div className="LoadinComponent">
                <TailSpin color="#334D52" height={30} width={30} />
              </div>
            }
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
            fixedHeader
          />
        </div>

        {donwloadModel?.isOpen && <DownloadFilterModel donwloadModel={donwloadModel} setDonwloadModel={setDonwloadModel} handleCloseDownloadModel={handleCloseDownloadModel} handleOnChange={handleOnChange} handleChangeAssign={handleChangeAssign} id={null} />}
      </div>
    </div>
  );
}
